<!-- 任务2 -->
<template>
  <div>
    <div class="course_Task2">
      <el-row
        style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);"
      >
        <!-- <template v-if="examType == 2">
            <p style="background-color: rgb(239, 242, 247);margin: 0 -20px;color: #2789E2;padding: 20px;">任务得分：{{scoreInfo.score || 0}} 分 学习时长：{{scoreInfo.time || 0}} 分钟</p>
          </template> -->
        <p class="fontB">
          <i class="el-icon-document-remove icon_"></i>任务名称：<span
            style="font-weight: 500;"
            >{{ taskInfo.taskTitle }}</span
          >
        </p>
        <p class="fontB">
          <i class="el-icon-s-data icon_" style="color: #8a39c2;"></i>任务分值：
          <span style="font-weight: 500;">{{ taskInfo.taskScore }} 分</span>
          <template v-if="examType == 2">
            <span style="color: red;margin-left: 100px;"
              >任务得分：{{ scoreInfo.score || 0 }} 分</span
            >
            <span style="color: red;margin-left: 100px;"
              >学习时长：{{ scoreInfo.time || 0 }} 分钟</span
            >
          </template>
        </p>
        <p class="fontB">
          <i class="el-icon-document-copy icon_"></i>考核内容：
        </p>
        <el-row class="aljj">
          <p>1、至少观看{{ taskInfo.assessmentRequirements }}分钟PPT</p>
          <p>2、每隔{{ taskInfo.assessmentTime }}分钟弹出一次验证框</p>
        </el-row>
        <p class="fontB">
          <i class="el-icon-edit-outline icon_" style="color: #2eb68e;"></i
          >考核任务：
        </p>
        <el-row>
          <el-col :span="12">
            <el-table
              border
              :data="tableData"
              style="width: calc(100% - 20px);"
            >
              <el-table-column
                type="index"
                header-align="center"
                align="center"
                width="100"
                label="序号"
              ></el-table-column>
              <el-table-column
                prop="fileName"
                header-align="center"
                align="center"
                label="PPT名称"
              ></el-table-column>
              <el-table-column
                prop="schedule"
                header-align="center"
                align="center"
                label="观看时间 (分钟)"
                width="120"
              >
                <template slot-scope="scope">
                  <span style="color: #F83131;">{{
                    $returnMin(Number(scope.row.schedule, 1) * 1000)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="_"
                header-align="center"
                align="center"
                label="操作"
                width="120"
              >
                <template slot-scope="scope">
                  <el-link
                    type="primary"
                    :underline="false"
                    @click="seePpt(scope.row, scope.$index)"
                  >
                    <span
                      :style="'color:' + (onNum == scope.$index ? 'red' : '')"
                      >{{ scope.row.schedule <= 0 ? "观看" : "继续观看" }}</span
                    >
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <!-- <el-col :span="14" v-if='examType == 1'>
              <el-row style="width: 100%;height: 500px;background-color:#E5E5E5;line-height: 300px;text-align: center;">
                <iframe v-if="URLInfo" id="InformationURL" :src='URLInfo+"#toolbar=0"' width='100%' height='100%' frameborder='1'></iframe>
                <p v-if="!URLInfo">PPT播放</p>
              </el-row>
            </el-col> -->
        </el-row>
        <el-row style="margin: 20px 0;">
          <el-row
            style="width: 100%;height: 600px;background-color:#E5E5E5;line-height: 300px;text-align: center;"
          >
            <lookPdf v-if="URLInfo" :pdfUrl="URLInfo"></lookPdf>
            <!-- <iframe v-if="URLInfo" id="InformationURL" :src='URLInfo+"#toolbar=0"' width='100%' height='100%' frameborder='1'></iframe> -->
            <p v-if="!URLInfo">PPT播放</p>
          </el-row>
        </el-row>
      </el-row>
    </div>

    <el-dialog
      title="输入验证码继续观看"
      :showClose="false"
      :closeOnClickModal="false"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-row class="el_form_">
        <el-col :span="14" class="tc pr20">
          <el-input
            v-model="verificationCode"
            clearable
            placeholder="请输入数字验证码"
          ></el-input>
        </el-col>
        <el-col :span="10" class="tc">
          <p
            class="m0"
            style="line-height: 38px;border: 1px solid #E1E1E1;border-radius: 3px;"
          >
            <SIdentify ref="SIdentify" v-if="dialogVisible"></SIdentify>
          </p>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSIdentify">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SIdentify from "@/components/SIdentify"; //验证码
import lookPdf from "@/components/lookPdf"; //引入PDF查看器
export default {
  name: "Task2",
  components: {
    SIdentify,
    lookPdf
  },
  props: {
    examType: {
      //考试类型 1：考试 2：查看成绩
      type: Number,
      default: function() {
        return 1;
      }
    },
    taskId: {
      //任务ID
      type: String,
      default: function() {
        return "";
      }
    },
    scoreInfo: {
      //分值信息
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      tableData: [],
      taskInfo: {}, //任务详情
      URLInfo: "",
      onTime: 0, //当前倒计时秒数
      onNum: 0, //当前查看的PPT位置
      intervalInfo: null,
      dialogVisible: false,
      verificationCode: "", //验证码
      intervalUserInfo: null, //token过期
      studentHandsOnTaskPptId: ""
    };
  },
  created() {
    this.getInfo();
    this.getHandsOnTaskkPptByTaskId();
  },
  mounted() {},
  methods: {
    getInfo() {
      //获取详情
      this.$get("/api/teacherOpenCourseHandsOnSimulationTasks/getInfo.do", {
        taskId: this.taskId
      }).then(ret => {
        if (ret.code == 0) {
          this.taskInfo = ret.data;
          if (this.taskInfo.assessmentTime > 20) {
            this.intervalUserInfo = setInterval(() => {
              this.getUserInfo();
            }, 20 * 60 * 1000);
          }
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    getHandsOnTaskkPptByTaskId() {
      //获取学生观看视频数据
      this.$get("/api/studentHandsOnTaskPpt/getHandsOnTaskkPptByTaskId", {
        taskId: this.taskId,
        sourceType: this.examType
      }).then(ret => {
        if (ret.code == 0) {
          this.tableData = ret.data.pptFiles;
          this.studentHandsOnTaskPptId = ret.data.studentHandsOnTaskPptId;
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    seePpt(item, index) {
      //查看PPT
      this.onNum = index;
      if (this.intervalInfo) {
        clearInterval(this.intervalInfo);
      }
      this.onTime = 0;
      if (this.examType == 1) {
        this.timerInfo(); //开始计时
      }
      this.URLInfo = this.$isHttp(item.fileUrl);
    },
    timerInfo() {
      let assessmentTime = this.taskInfo.assessmentTime; //多少间隔停止一次（分钟）
      if (assessmentTime <= 0) {
        this.intervalInfo = setInterval(() => {
          this.taskLogInfo();
        }, 5000);
        return;
      }
      this.intervalInfo = setInterval(() => {
        this.onTime++;
        if (this.onTime == assessmentTime * 60) {
          this.dialogVisible = true;
          this.onTime = 0;
          clearInterval(this.intervalInfo);
        }
        if (this.onTime % 5 == 0) {
          //5秒钟调用一次数据修改
          let onSchedule = this.tableData[this.onNum].schedule || 0;
          this.tableData[this.onNum].schedule = Number(onSchedule) + 5;
          this.editTaskVideo({ pptFile: JSON.stringify(this.tableData) });
          this.taskLogInfo(this.taskId);
        }
      }, 1000);
    },
    confirmSIdentify() {
      //确认验证码
      if (this.verificationCode == this.$refs.SIdentify.identifyCodeTemp) {
        this.timerInfo();
        this.verificationCode = "";
        this.dialogVisible = false;
        if (this.taskInfo.assessmentTime <= 20) {
          this.getUserInfo();
        }
      } else {
        this.$message.warning("验证码错误！");
        return;
      }
    },
    editTaskVideo(param) {
      //提交数据
      param.handsOnTaskId = this.taskId;
      param.handsOnId = this.handsOnId;
      param.studentHandsOnTaskPptId = this.studentHandsOnTaskPptId;
      this.$post("/api/studentHandsOnTaskPpt/add.do", param).then(ret => {
        if (ret.code == 0) {
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    taskLogInfo(handsOnTaskId) {
      this.$post("/api/studentHandsOnTaskLog/add.do", {
        handsOnTaskId: handsOnTaskId,
        taskType: "TASK_PPT"
      }).then(ret => {
        if (ret.code == 0) {
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    getUserInfo() {
      //主要用于避免看视频时避免token过期
      this.$post("/api/base/userInfo.do").then(ret => {});
    }
  },
  beforeDestroy(key) {
    if (this.intervalInfo) {
      clearInterval(this.intervalInfo);
    }

    if (this.intervalUserInfo) {
      clearInterval(this.intervalUserInfo);
    }
  }
};
</script>
<style lang="less">
.course_Task2 {
  .icon_ {
    color: #2789e2;
    margin-right: 10px;
  }
  .has-gutter {
    th {
      border-color: #e5e5e5;
      background-color: #eff2f7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/course/components/PracticalTraining/Task2.vue